import { useIntl } from "react-intl";

import { BITBUCKET_SIGNUP_LIMIT } from "../configs/bitbucket.pricing-calculator-config.ts";
import * as messages from "../messages.ts";

import { PriceAltContainer } from "./price-alt-container.tsx";
import {
    ProductPriceCardProps,
    StandardPriceCard,
    PremiumPriceCard
} from "./pricing-calculator-plan-card.tsx";

export const BitbucketStandardPriceCard = (props: ProductPriceCardProps) => {
    const intl = useIntl();

    const formattedLimit = intl.formatNumber(BITBUCKET_SIGNUP_LIMIT);

    return (
        <StandardPriceCard
            {...props}
            priceAltElementForAboveMaxThreshold={
                <PriceAltContainer>
                    {intl.formatMessage(
                        messages.aboveUnitMaxThreshold.specificCount,
                        { lowerLimit: formattedLimit }
                    )}
                </PriceAltContainer>
            }
        />
    );
};

export const BitbucketPremiumPriceCard = (props: ProductPriceCardProps) => {
    const intl = useIntl();
    const formattedLimit = intl.formatNumber(BITBUCKET_SIGNUP_LIMIT);

    return (
        <PremiumPriceCard
            {...props}
            priceAltElementForAboveMaxThreshold={
                <PriceAltContainer>
                    {intl.formatMessage(
                        messages.aboveUnitMaxThreshold.specificCount,
                        { lowerLimit: formattedLimit }
                    )}
                </PriceAltContainer>
            }
        />
    );
};
